import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/outline";
import { observer } from "mobx-react-lite";

import { useGridContext, ViewMode } from "../../../hooks/useEvaluateGridContext";

export const getBooleanColors = (value: boolean) =>
  value
    ? "bg-green-100 group-hover:bg-green-200 transition-colors duration-200"
    : "bg-red-100 group-hover:bg-red-200 transition-colors duration-200";

export const BooleanIcon = observer(({ value }: { value: boolean }) => {
  const { tableStore } = useGridContext();
  const isCompactMode = tableStore?.viewMode === ViewMode.COMPACT;
  const iconSize = isCompactMode ? "h-4 w-4" : "h-5 w-5";
  return value ? (
    <CheckCircleIcon className={`${iconSize} text-green-600`} />
  ) : (
    <XCircleIcon className={`${iconSize} text-red-600`} />
  );
});
